<template>
  <div class="min-h-screen bg-gray-50 dark:bg-gray-900">
    <div class="max-w-6xl mx-auto">
      <div class="lg:hidden">
        <USkeleton class="w-full aspect-[4/3]" />
        <div class="p-4 space-y-4 bg-white dark:bg-gray-800">
          <div class="flex items-center gap-3">
            <USkeleton class="h-10 w-10 rounded-full" />
            <USkeleton class="h-4 w-32" />
          </div>
          <USkeleton class="h-7 w-3/4" />
          <div class="space-y-2">
            <USkeleton class="h-3 w-full rounded-full" />
            <div class="flex justify-between">
              <USkeleton class="h-5 w-24" />
              <USkeleton class="h-4 w-16" />
            </div>
          </div>
          <div class="flex gap-3">
            <USkeleton class="h-12 flex-1 rounded-lg" />
            <USkeleton class="h-12 w-12 rounded-lg" />
          </div>
        </div>
      </div>
      <div class="hidden lg:block text-center mb-8 px-4 pt-8">
        <USkeleton class="h-10 w-96 mx-auto mb-3" />
      </div>
      <div class="grid grid-cols-1 lg:grid-cols-3 gap-8 px-4 py-6 lg:py-0">
        <div class="hidden lg:block lg:col-span-1">
          <div class="sticky top-8 space-y-6">
            <div class="bg-white dark:bg-gray-800 rounded-2xl overflow-hidden shadow-lg">
              <USkeleton class="w-full aspect-[4/3]" />
              <div class="p-5 space-y-4">
                <div class="flex items-center gap-3">
                  <USkeleton class="h-10 w-10 rounded-full" />
                  <div class="space-y-1">
                    <USkeleton class="h-4 w-28" />
                    <USkeleton class="h-3 w-20" />
                  </div>
                </div>
                <div class="space-y-2">
                  <USkeleton class="h-2 w-full rounded-full" />
                  <div class="flex justify-between">
                    <USkeleton class="h-6 w-28" />
                    <USkeleton class="h-4 w-16" />
                  </div>
                </div>
                <div class="flex justify-between pt-2">
                  <USkeleton class="h-4 w-24" />
                  <USkeleton class="h-4 w-20" />
                </div>
                <div class="space-y-3 pt-2">
                  <USkeleton class="h-12 w-full rounded-xl" />
                  <USkeleton class="h-10 w-full rounded-xl" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="lg:col-span-2 space-y-4">
          <div class="bg-white dark:bg-gray-800 rounded-xl p-4">
            <div class="flex items-center gap-3">
              <USkeleton class="h-8 w-8 rounded-full" />
              <div class="space-y-1 flex-1">
                <USkeleton class="h-4 w-40" />
                <USkeleton class="h-3 w-64" />
              </div>
            </div>
          </div>
          <div class="bg-white dark:bg-gray-800 rounded-xl overflow-hidden">
            <div class="flex border-b border-gray-100 dark:border-gray-700 p-1">
              <USkeleton class="h-10 w-32 rounded-lg" />
              <USkeleton class="h-10 w-32 rounded-lg ml-2" />
            </div>
            <div class="p-5 space-y-4">
              <USkeleton class="h-5 w-full" />
              <USkeleton class="h-5 w-full" />
              <USkeleton class="h-5 w-3/4" />
              <USkeleton class="h-5 w-full" />
              <USkeleton class="h-5 w-5/6" />
              <USkeleton class="h-5 w-2/3" />
            </div>
          </div>
          <div class="bg-white dark:bg-gray-800 rounded-xl p-4">
            <div class="flex items-center gap-2">
              <div class="flex -space-x-2">
                <USkeleton class="h-8 w-8 rounded-full ring-2 ring-white dark:ring-gray-800" />
                <USkeleton class="h-8 w-8 rounded-full ring-2 ring-white dark:ring-gray-800" />
                <USkeleton class="h-8 w-8 rounded-full ring-2 ring-white dark:ring-gray-800" />
              </div>
              <USkeleton class="h-4 w-32" />
            </div>
          </div>
          <div class="bg-white dark:bg-gray-800 rounded-xl p-5 space-y-4">
            <div class="flex items-center justify-between">
              <USkeleton class="h-5 w-36" />
              <USkeleton class="h-8 w-24 rounded-lg" />
            </div>
            <div class="space-y-3">
              <div v-for="i in 3" :key="i" class="flex items-center gap-3 p-3 bg-gray-50 dark:bg-gray-700/50 rounded-xl">
                <USkeleton class="h-10 w-10 rounded-full" />
                <div class="flex-1 space-y-1">
                  <USkeleton class="h-4 w-28" />
                  <USkeleton class="h-3 w-20" />
                </div>
                <USkeleton class="h-5 w-16" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
